import * as Yup from "yup";

export const affiliateLevelDiscountValidation = Yup.object().shape({
  name: Yup.string()
    .required("وارد کردن نام تخفیف الزامی است"),
    percent: Yup.number()
    .typeError("درصد تخفیف باید عدد باشد")
    .min(0, "درصد تخفیف باید بین ۰ تا ۱۰۰ باشد")
    .max(100, "درصد تخفیف باید بین ۰ تا ۱۰۰ باشد")
    .required("وارد کردن درصد تخفیف الزامی است"),
    minPrice: Yup.string()
    .required("وارد کردن کف قیمت الزامی است"),
    maxPrice: Yup.string()
    .required("وارد کردن سقف قیمت الزامی است"),
});
